$(document).ready(function(){
	// LANGUAGE
	var lang_id = $('#lang_id').val();
	
	$('#JSRegToggle').click(function(){
		if($('#JSRegToggleSec').attr('hidden') == 'hidden'){
			$('#JSRegToggleSec').removeAttr('hidden');
		}else{
			$('#JSRegToggleSec').attr('hidden','true');
		}
	});

	$('#JSAddCartSubmit').click(function(){
		$(this).attr('disabled',true);
		if($(this).hasClass('JSadd-to-cart-and-animation')){
			setTimeout(() => {
				$('#JSAddCartForm').submit();
			}, 600);
		}
		else {
			$('#JSAddCartForm').submit();
		}
	});

	$(document).on('click','.JSadd-to-cart',function(){
		var obj = $(this),
		roba_id = obj.data('roba_id');

		$.post(base_url+'list-cart-add',{roba_id: roba_id},function(response){

			window.toast(lang_id === 'en'  ? 'Product has been added to cart' : 'Artikal je dodat u korpu');

			var results = $.parseJSON(response);
			
			if(parseInt(results.check_available) == 0){
				obj.after('<button class="not-available btn bg-danger text-white btn-sm">'+ (lang_id == 'en' ? 'Not available' : 'Nije dostupno') +'</button>');
				obj.remove();
			}
			$('.JSheader-cart-content').html(results.mini_cart_list);
			$('.JScart_num').text(results.broj_cart);	
			if($('#livemode').val() == 1){
				gtagManagerAddToCart(results.article_details);
			}		

		});
	});

	//ADD TO CART AND ANIMATION
	$('.JSadd-to-cart-and-animation, .JSadd-to-cart-similar-animation').each(function(i, item) {
		$(this).on('click', function (){
			$(this).attr('disabled', true);
			let place_cart_animation_icon = $('.header-cart .JSplace-cart-animation-icon'),
			place_cart_finsih_left = place_cart_animation_icon.offset().left,
			place_cart_finsih_top = place_cart_animation_icon.offset().top - $(window).scrollTop(),
			place_cart_finsih_width = place_cart_animation_icon.width(),
			place_cart_finsih_height = place_cart_animation_icon.height(),
			shop_product_card = $(this).parents('.JSanimation'),
			article_img_position_top = shop_product_card.find('.JSanimation-image').offset().top - $(window).scrollTop(),
			article_img_position_left = shop_product_card.find('.JSanimation-image').offset().left;
			shop_product_card.find('.JSanimation-image').clone().appendTo(".JSplace-for-items");

			$('.JSplace-for-items img').css({
				'position' : 'fixed',
				'top' : article_img_position_top,
				'left' : article_img_position_left
			});
			$('.JSplace-for-items .JSanimation-image-max-size').css({
				'max-width' : '300' + 'px',
				'max-height' : '200' + 'px'
			});
			$('.JSplace-for-items .JSanimation-image-list-max-size').css({
				'max-width' : '250' + 'px',
				'max-height' : '150' + 'px'
			});
			$('.JSplace-for-items .JSanimation-article-page-image-max-size').css({
				'max-width' : '400' + 'px',
				'max-height' : '300' + 'px'
			});
// -------------------------------------
			$('.JSplace-for-items img').animate({
				top : place_cart_finsih_top,
				left : place_cart_finsih_left,
				width: place_cart_finsih_width,
				height: place_cart_finsih_height,
				opacity : '1'
			}, 1000 , function() {
				$('.JSanimation .buy-btn').attr('disabled', false);
				$('.JSplace-for-items img').remove();
			});
// ------------------------------------
			setTimeout(() => {
				if($(this).hasClass('JSadd-to-cart-and-animation')){
					var obj = $(this),
					roba_id = obj.data('roba_id');

					$.post(base_url+'list-cart-add',{roba_id: roba_id},function(response){

						window.toast(lang_id === 'en'  ? 'Product has been added to cart' : 'Artikal je dodat u korpu');

						var results = $.parseJSON(response);

						if(parseInt(results.check_available) == 0){
							obj.after('<button class="not-available btn bg-danger text-white btn-sm">'+ (lang_id == 'en' ? 'Not available' : 'Nije dostupno') +'</button>');
							obj.remove();
						}
						$('.JSheader-cart-content').html(results.mini_cart_list);
						$('.JScart_num').text(results.broj_cart);	
						if($('#livemode').val() == 1){
							gtagManagerAddToCart(results.article_details);
						}		
					});
				}
				else if($(this).hasClass('JSadd-to-cart-similar-animation')){
					var obj = $(this),
					roba_id = obj.data('roba_id'),
					vezani_roba_id = obj.data('vezani_roba_id'),
					kolicina = 1;

					$.post(base_url+'vezani-cart-add',{roba_id: roba_id, vezani_roba_id: vezani_roba_id, kolicina: kolicina},function(response){
						var results = $.parseJSON(response); 
						if(results.success){ 

							window.toast(lang_id === 'en'  ? 'Product has been added to cart' : 'Artikal je dodat u korpu');

							if(results.check_available <= 0){
								obj.after('<button class="not-available btn bg-danger text-white btn-sm">'+ (lang_id == 'en' ? 'Not available' : 'Nije dostupno') +'</button>');
								obj.remove();			
							}
							$('.JSheader-cart-content').html(results.mini_cart_list);
							$('.JScart_num').text(results.broj_cart);
							if($('#livemode').val() == 1){
								gtagManagerAddToCart(results.article_details);
							}	
						} else {

							if(results.exists == 0){ 
								window.toast(lang_id === 'en'  ? 'Requested amount notavailable' : 'Tražena količina nije dostupna', 'error');

							}else{ 
								window.toast(lang_id === 'en'  ? 'Product has already been added to cart' : 'Artikal je već dodat u korpu');

							}
						}

					});  
				}
			}, 600);
		});
	});
	//END ADD TO CART END ANIMATION

	$('.JSadd-to-cart-similar').click(function(){
		var obj = $(this),
		roba_id = obj.data('roba_id'),
		vezani_roba_id = obj.data('vezani_roba_id'),
		kolicina = 1;

		$.post(base_url+'vezani-cart-add',{roba_id: roba_id, vezani_roba_id: vezani_roba_id, kolicina: kolicina},function(response){
			var results = $.parseJSON(response); 
			if(results.success){ 

				window.toast(lang_id === 'en'  ? 'Product has been added to cart' : 'Artikal je dodat u korpu');

				if(results.check_available <= 0){
					obj.after('<button class="not-available btn bg-danger text-white btn-sm">'+ (lang_id == 'en' ? 'Not available' : 'Nije dostupno') +'</button>');
					obj.remove();			
				}
				$('.JSheader-cart-content').html(results.mini_cart_list);
				$('.JScart_num').text(results.broj_cart);
				if($('#livemode').val() == 1){
					gtagManagerAddToCart(results.article_details);
				}	
			} else {

				if(results.exists == 0){ 

					window.toast(lang_id === 'en'  ? 'Requested amount notavailable' : 'Tražena količina nije dostupna', 'error');

				}else{ 

					window.toast(lang_id === 'en'  ? 'Product has already been added to cart' : 'Artikal je već dodat u korpu');

				}
			}
		});  
	});

	$('.JScart-less, .JScart-more, .JScart-less-gram, .JScart-more-gram').click(function(){
		var obj = $(this),
		stavka_id = obj.data('stavka_id'),
		kolicina_temp = obj.closest('li').find('.JScart-amount').val(),
		kolicina;

		if(obj.attr('class') == 'JScart-less'){
			kolicina = parseInt(kolicina_temp) - 1;
		}
		else if(obj.attr('class') == 'JScart-more'){
			kolicina = parseInt(kolicina_temp) + 1;
		}
		else if(obj.attr('class') == 'JScart-less-gram'){
			kolicina = (parseFloat(kolicina_temp) - 1/10).toFixed(2);
		}
		else if(obj.attr('class') == 'JScart-more-gram'){			
			kolicina = (parseFloat(kolicina_temp) + 1/10).toFixed(2);
		}

		if(kolicina > 0){		
			$.post(base_url+'cart-add-sub',{stavka_id: stavka_id, kolicina: kolicina},function(response){
				var results = $.parseJSON(response);
				if(results.changed){
					obj.closest('li').find('.JScart-amount').val(kolicina);					
					obj.closest('ul').find('.JScart-item-price').html(results.cart_item_ukupno);					
					console.log(results.troskovi_isporuke)
					$('.JSdelivery_total_amount').html(results.cart_ukupno);
					$('.JSUkupno_sa_dostavom').html(results.cart_item_ukupno_dostava);
					$('.JStotal_amount_weight').html(results.cart_item_ukupno_tezina);
					$('.JSheader-cart-content').html(results.mini_cart_list);
					$('.JScart_num').text(results.broj_cart);
					$('#JSAchievePoints').text(results.bodovi_ostvareni_bodovi_korpa);
					$('#JSMaxUsingPoints').text(results.bodovi_popust_bodovi_korpa);
					$('#JSMaxUsingVoucherPrice').html(results.vauceri_popust_cena_korpa);
					$('.JSexpenses').html(results.troskovi_isporuke_valuta);

					if(results.troskovi_isporuke>0){
						$('.JSdelivery_total_amountParent').show()
						$('.JSDelivery').show()
						$('.cart-summ div:first-child').show();
						$('.cart-summ-info').hide();
					}else{
						$('.JSdelivery_total_amountParent').hide();
						$('.JSDelivery').hide();
						$('.cart-summ-info').hide();
						$('.cart-summ div:first-child').hide();	
						var freeDelivery = '<div class="cart-summ-info justify-right"><span><b>+Besplatna dostava</b></span></div>';
						$('.cart-summ div:last-child').before(freeDelivery)
					}

					for (var i=0; i < results.vezane_stavke.length; i++) {
						var vezani_id = results.vezane_stavke[i].web_b2c_korpa_stavka_id;
						var vezani_kolicina = parseFloat(results.vezane_stavke[i].kolicina).toFixed(0);
						$('.JScart-amount[data-stavka_id='+vezani_id+']').val(vezani_kolicina);
						$('.JScart-item-price[data-stavka_id='+vezani_id+']').html(results.vezane_stavke[i].vezani_item_cena);
					}
					window.toast(lang_id === 'en'  ? 'Amount changed' : 'Količina je promenjena');

				} else {
					window.toast(lang_id === 'en'  ? 'Requested amount not available' : 'Tražena količina nije dostupna', 'error');
				}

				if(results.changed && $('#livemode').val() == 1){
					if(results.article_details.quantity > 0){
						gtagManagerAddToCart(results.article_details);
					}else{
						gtagManagerRemoveFromCart([results.article_details]);
					}
				}
			});

		} else {  

			window.toast(lang_id === 'en'  ? 'Amount can not be less than 1' : 'Količina ne sme biti manja od 1', 'error');

		}  
	});


	$('.JScart-amount').keyup(function(){
		var obj = $(this),
		stavka_id = obj.data('stavka_id'),
		kolicina = $(this).val();
		
		if(kolicina > 0){		
			$.post(base_url+'cart-add-sub',{stavka_id: stavka_id, kolicina: kolicina},function(response){
				var results = $.parseJSON(response);
				if(results.changed){
					obj.closest('li').find('.JScart-amount').val(kolicina);					
					obj.closest('ul').find('.JScart-item-price').html(results.cart_item_ukupno);					

					$('.JSdelivery_total_amount').html(results.cart_ukupno);
					$('.JSUkupno_sa_dostavom').html(results.cart_item_ukupno_dostava);
					$('.JStotal_amount_weight').html(results.cart_item_ukupno_tezina);
					$('.JSheader-cart-content').html(results.mini_cart_list);
					$('.JScart_num').text(results.broj_cart);	
					$('#JSAchievePoints').text(results.bodovi_ostvareni_bodovi_korpa);
					$('#JSMaxUsingPoints').text(results.bodovi_popust_bodovi_korpa);
					$('#JSMaxUsingVoucherPrice').html(results.vauceri_popust_cena_korpa);


					window.toast(lang_id === 'en'  ? 'Amount changed' : 'Količina je promenjena');

					if(results.article_details.quantity > 0){
						gtagManagerAddToCart(results.article_details);
					}else{
						results.article_details.quantity = -results.article_details.quantity;
						gtagManagerRemoveFromCart([results.article_details]);
					}
				} else {
					window.toast(lang_id === 'en'  ? 'Requested amount not available' : 'Tražena količina nije dostupna', 'error');

				}
			});

		} else {
			window.toast(lang_id === 'en'  ? 'Amount can not be less than 1' : 'Količina ne sme biti manja od 1', 'error');
		}
	});


	$(document).on('click','.JSdelete_cart_item',function(){
		var stavka_id = $(this).data('stavka_id');

		confirmDialog({
		 	title: lang_id === 'en' ? 'Product will be removed from cart. Are you sure?' : 'Artikal će biti uklonjen iz korpe. Da li ste sigurni?',
		}).then((result) => {
		  	if (result.isConfirmed) {
				$.post(base_url+'cart-stavka-delete',{stavka_id: stavka_id},function(response){ 
					window.toast(lang_id === 'en'  ? 'Product has been removed from cart' : 'Artikal je uklonjen iz korpe');

					setTimeout(function(){
						location.reload(); 
					}, 600);  
				}); 
			}
		});
	});
	

	$('#JSDeleteCart').click(function(){
		confirmDialog({
		  title: lang_id == 'en' ? 'Are you sure you want to empty the cart?' : 'Da li ste sigurni da želite da ispraznite korpu?',
		  icon: "warning",
		}).then((result) => {
		  if (result.isConfirmed) {
		
			$.post(base_url+'cart-delete',{},function(response){  

				setTimeout(function(){
					location.reload(); 
				}, 600); 
			});
			window.toast(lang_id === 'en'  ? 'Cart has been emptied' : 'Korpa je ispražnjena');

		  }
		});
	});


	$('#JSvoucherSend').click(function(){
		var vaucer_broj = $('#vaucer_code').val(),
		cart_ukupno = $('#cartBasePrice').val();

		confirmDialog({
		  title: lang_id == 'en' ? 'Are you sure you want to use the voucher?' : 'Da li ste sigurni da želite da primenite vaučer?',
		  icon: "warning",
		}).then((result) => {
		  	if (result.isConfirmed) {
		
				$.post(base_url+'vaucer-primeni',{vaucer_broj: vaucer_broj, cart_ukupno: cart_ukupno},function(response){ 
					var results = $.parseJSON(response); 

					// console.log(results.vaucer_broj);

					if(results.success){ 
						window.toast(lang_id === 'en'  ? 'Voucher applied' : 'Vaučer uspešno primenjen');

						setTimeout(function(){
							location.reload(); 
						}, 600);  
					} else {

						window.toast(lang_id === 'en'  ? 'Voucher is invalid' : 'Vaučer neispravan ili već iskorišćen');
					}
				});
		  	}
		});
	});

	$('.JSremoveCoupon').click(function(){
		var vaucer_broj = $(this).attr('coupon'),
		cart_ukupno = $('#cartBasePrice').val();

		confirmDialog({
		  title: lang_id == 'en' ? 'Are you sure you wish to deactivate your voucher?' : 'Da li ste sigurni da želite da deaktivirate vaučer?',
		  icon: "warning",
		}).then((result) => {
		  	if (result.isConfirmed) {
		
				$.post(base_url+'vaucer-obrisi',{vaucer_broj: vaucer_broj, cart_ukupno: cart_ukupno},function(response){ 
					var results = $.parseJSON(response); 

					// console.log(results.vaucer_broj);
					if(results.success){ 
						window.toast(lang_id === 'en'  ? 'Voucher successfully deactivated' : 'Vaučer uspešno deaktiviran');

						setTimeout(function(){
							location.reload(); 
						}, 600);  
					} else {
						window.toast(lang_id === 'en'  ? 'Voucher is invalid' : 'Vaučer neispravan ili već iskorišćen');
					}
				});
		  	}
		});
	});

	$(document).on('click','.JSnot_logged',function(){
		window.toast(
			lang_id === 'en'  ? 'To add a product to your wish list, you need to be logged in' : 'Da biste dodali proizvod na listu želja, morate biti ulogovani',
			'error'
		);
	});


	$(document).on('click','.JSadd-to-wish',function(){ 
		var roba_id = $(this).data('roba_id');

		$.post(base_url+'wish-list-add',{roba_id: roba_id},function(response){
			var results = $.parseJSON(response);

			window.toast(results.message);

			$('.JSbroj_wish').text(results.broj_wish);
		});
	});


	$(document).on('click','.JSukloni',function(){
		var roba_id = $(this).data('roba_id');
		confirmDialog({
		  title: lang_id == 'en' ? 'Product will be removed from your wish list. Are you sure?' : 'Artikal će biti uklonjen sa liste želja. Da li ste sigurni?',
		  icon: "warning",
		}).then((result) => {
		  	if (result.isConfirmed) {
				$.post(base_url+'wish-list-delete',{roba_id: roba_id},function(response){
					window.toast(lang_id === 'en'  ? 'Product has been removed from your wish list' : 'Artikal je uklonjen iz liste želja');
					
					setTimeout(function(){
						location.reload(); 
					}, 600);
				});
		  	}
		});
	});

	$('.JSdeliveryInput').on('change', function(){
		if(parseFloat($('.JSexpenses').data('troskovi'))>0 && $(this).val() != 2){
			$('#JSWithoutExpensesContent').attr('hidden','hidden');
			$('#JSExpensesContent').removeAttr('hidden');
		}else{
			$('#JSWithoutExpensesContent').removeAttr('hidden');
			$('#JSExpensesContent').attr('hidden','hidden');
		}
	});

	
	$('.JS_total_price').on('DOMSubtreeModified', function(){
		var price = $(this).text(),
		divs = $(this).parent().prevAll('.JS_price_adds'),
		free_delivery = $(this).nextAll('.JS_free_del'), 
		original_price = $(this).next().data('dostava');

		if (price > original_price) { 
			$(this).hide();
			divs.hide(); 
			free_delivery.removeAttr('hidden');
		}else{
			$(this).show();
			divs.show(); 
			free_delivery.attr('hidden', 'hidden'); 
		}
		// var ukupno_repl = (ukupno.replace(/[^\d]/g,'')/100);
		// var dostava = $(this).data('dostava');
		// var JS_free_del = $('.JS_free_del'); 
		// var razlika = ukupno_repl-dostava;
		// console.log(dostava) 
		// if(razlika < 0){
		// $('.JSfree_delivery').hide(); 
		// }else{
		// $('.JSfree_delivery').show();  
		// } 
	});


	if($('select[name="web_nacin_placanja_id"]').val() == 3){
		$('#JSCaptcha').removeAttr('hidden');
	}
	$(document).on('change','select[name="web_nacin_placanja_id"]',function(){
		if($(this).val() == 3){
			$('#JSCaptcha').removeAttr('hidden');
		}else{
			$('#JSCaptcha').attr('hidden','hidden');
		}
	});

});

function gtagManagerAddToCart(productObj) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'eec.add',
		'ecommerce': {
			'currencyCode': productObj.currency,
			'add': {
				'products': [{
					'name': productObj.name,
					'content_type': 'product_group',
					"item_group_id": productObj.category_id,
					'id': parseInt(productObj.id),
					'price': productObj.price,
					'brand': productObj.brand,
					'category': productObj.category,
					"variant": "Standard",
					'quantity': productObj.quantity
				}]
			}
		},
		'eventCallback': function() {

		}
	});
}

function gtagManagerRemoveFromCart(productObjects) {
	if(productObjects.length > 0){	
		var products = [];
		for (var i = 0; i < productObjects.length; i++) {
			products.push({
				'name': productObjects[i].name,
				'content_type': 'product_group',
				"item_group_id": productObjects[i].category_id,
				'id': parseInt(productObjects[i].id),
				'price': productObjects[i].price,
				'brand': productObjects[i].brand,
				'category': productObjects[i].category,
				"variant": "Standard",
				'quantity': -productObjects[i].quantity
			});
		}

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'eec.remove',
			'ecommerce': {
				'currencyCode': productObjects[0].currency,
				'remove': {
					'products': products
				}
			},
			'eventCallback': function() {

			}
		});
	}
}
function validate(evt) {
	var theEvent = evt || window.event;
	var key = theEvent.keyCode || theEvent.which;
	key = String.fromCharCode( key );
	var regex = /[0-9]|\./;
	if( !regex.test(key) ) {
		theEvent.returnValue = false;
		if(theEvent.preventDefault) theEvent.preventDefault();
	}
} 
